import axiosApi from './common/api';

const baseAPI = 'categories/';

class CategoryService {

  insertItem(item: any, type: string) {
    return axiosApi.post(baseAPI, { item, "type": type });
  }

  updateItem(id: string, item: object) {
    return axiosApi.put(baseAPI + id, { item });
  }

  deleteItem(id: string) {
    return axiosApi.delete(baseAPI + id);
  }

  getItems(skip: number, limit: number) {
    return this.getSearch(skip, limit, "");    
  }

  getSearch(skip: number, limit: number, search: string) {
    try {
        let paramString =`?__skip=${skip}&__limit=${limit}`;
        if (search?.length > 0)
          paramString = paramString + "&__search=" + search;
        return axiosApi.get(baseAPI + paramString).then((response: Response) => {
          return response;
        });
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }    
  }

  getPublishedItems(skip: number, limit: number) {
    try {
        return axiosApi.get(baseAPI + `published?__skip=${skip}&__limit=${limit}`).then((response: Response) => {
          return response;
        });
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }    
  }

  getStats() {
      return axiosApi.get(baseAPI + "count").then((response: Response) => {
        return response;
      }).catch((error: any) => {
        throw error;
      });    
  }
  
  getItemById(id: string) {
    try {
        return axiosApi.get(baseAPI + id).then((response: Response) => {
          return response;
        });
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }    
  } 
}

export default new CategoryService();